import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL || ''}/api`;

// Global axios config — cookies sent automatically
const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Read CSRF token from cookie and attach to all state-changing requests
api.interceptors.request.use((config) => {
  const method = (config.method || '').toUpperCase();
  if (['POST', 'PUT', 'DELETE', 'PATCH'].includes(method)) {
    const csrfToken = getCookie('pp_csrf');
    if (csrfToken) {
      config.headers['x-csrf-token'] = csrfToken;
    }
  }
  return config;
});

function getCookie(name) {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  return match ? match[2] : '';
}

// Auth helpers
export async function login(email, password) {
  const { data } = await api.post('/auth/login', { email, password });
  return data;
}

export async function register(name, email, password) {
  const { data } = await api.post('/auth/register', { name, email, password });
  return data;
}

export async function logout() {
  await api.post('/auth/logout');
}

export async function checkAuth() {
  try {
    const { data } = await api.get('/auth/me');
    return data.authenticated;
  } catch {
    return false;
  }
}

export function getApiErrorMessage(error, fallback = 'Что-то пошло не так') {
  const detail = error?.response?.data?.detail;
  if (typeof detail === 'string' && detail.trim()) return detail;

  const details = Array.isArray(detail) ? detail : [detail];
  const messages = details
    .map((item) => {
      if (!item || typeof item !== 'object') return '';
      if (typeof item.message === 'string') return item.message;
      if (typeof item.msg === 'string') return item.msg;
      return '';
    })
    .filter(Boolean);

  return messages.length ? messages.join('. ') : fallback;
}

export default api;
